import * as React from 'react';
import * as types from 'modules/types/smSupplierManagement';
import { findDOMNode } from 'react-dom';
import { element } from 'utils';
import _ from 'lodash';
import { QuerySelectorHTMLElement } from 'modules/types/commons/dom';
import { Card, Form } from '@beehive/components';
import DotDotDot from '@mpc/common/src/components/DotDotDot';
import { BANK_INFO_KEYS, TRANSLATE_MAPPING_KEYS, getFormattedBankNumber } from '../utils';
import { getCurValue } from './ServiceInfo';
import PropTypes from 'prop-types';
import pageMessages from 'messages/Models/BankInfo';
import titleMessages from 'messages/CompanyManagement/CardTitle';
import classnames from 'classnames';

const messages = { ...pageMessages, ...titleMessages };

export type BankInfoProps = {
  bankInfoKeys?: any;
  inEdit?: boolean;
} & types.SupplierMangementDetail;

export default class BankInfo extends React.Component<BankInfoProps, any> {
  private thisDOM: Element | undefined;

  public static contextTypes = {
    intl: PropTypes.object,
  };

  constructor(props: BankInfoProps) {
    super(props);
    this.setCardHeight = _.debounce(this.setCardHeight, 100);
  }

  public componentDidMount() {
    const thisDOM = findDOMNode(this);
    if (thisDOM instanceof Element) {
      this.thisDOM = thisDOM;
    }
    window.addEventListener('resize', this.setCardHeight);
    this.setCardHeight();
  }

  public componentDidUpdate() {
    this.setCardHeight();
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.setCardHeight);
  }

  private setCardHeight = () => {
    //  bankInfo动态高度
    const { inEdit = false } = this.props;
    // @ts-ignore
    const parentRow = element.closest(this.thisDOM, inEdit ? '.beehive-row-flex' : '.beehive-row');
    if (parentRow) {
      const brotherElement: QuerySelectorHTMLElement = parentRow.firstElementChild;
      const contactElement: QuerySelectorHTMLElement =
        document.querySelector(inEdit ? '.beehive-card.contacts-info' : '.beehive-card.contact-info-show');
      const bankInfoElement: QuerySelectorHTMLElement = document.querySelector('.beehive-card.bank-info-show');
      if (contactElement && bankInfoElement && brotherElement) {
        const contactHeight = contactElement.clientHeight;
        const brotherElementHeight = brotherElement.clientHeight;
        const cardMargin = 16;  //  card间外边距
        const newHeight = brotherElementHeight - contactHeight - cardMargin;
        if (bankInfoElement.getBoundingClientRect().height < newHeight) {
          bankInfoElement.style.height = `${brotherElementHeight - contactHeight - cardMargin}px`;
        }
      }
    }

  }

  public render() {
    const { bank_info = {}, loading, bankInfoKeys = BANK_INFO_KEYS } = this.props;
    const { intl } = this.context;
    return (
      <Card
        titleNode={intl.formatMessage(messages.bankInfo)}
        className="bank-info-show"
        loading={loading}
      >
        <Form isLabelVertical>
          {
            Object.keys(bankInfoKeys).map((key: string) => {
              const item = BANK_INFO_KEYS[key];
              let value = bank_info[TRANSLATE_MAPPING_KEYS[key] ? TRANSLATE_MAPPING_KEYS[key].mapping_key : key];
              if (key === 'bank_number') {
                value = getFormattedBankNumber(value);
              }
              return (
                <Form.Item
                  label={item.label && intl.formatMessage(messages[item.label])}
                  key={key}
                  className={key}
                  itemColProps={{ span: 24 }}
                >
                  <span>
                    <DotDotDot clamp={1} className="bank-info-dot">
                      {getCurValue(value)}
                    </DotDotDot>
                  </span>
                </Form.Item>
              );
            })
          }
        </Form>
      </Card>
    );
  }
}
